module.exports = __webpack_public_path__ + "static/media/skill-seo-hero-3.2f7e46c0.jpg";